module.exports = __webpack_public_path__ + "img/agrogosubastasdark.3d6456f4.svg";